const customSelect = () => {
  const elements = document.querySelectorAll('.select')
  
  if (elements.length > 0) {
    for ( let i = 0; i < elements.length; i++ ) {
      new CustomSelect(`#${elements[i].id}`);
    }
  }
}

export default customSelect

